import { useTranslation } from 'react-i18next';
import { profile } from '../../content/profile.js';

export function Hero() {
  const { t } = useTranslation(['common', 'hero']);

  return (
    <div className="hero">
      <img
        className="hero__image"
        src={profile.hero.src}
        srcSet={profile.hero.srcSet}
        sizes="100vw"
        alt={t('common:portraitAlt')}
        width={1600}
        height={1600}
        // The hero is the largest paint on the page; lazy-loading it would
        // put it behind everything else.
        fetchPriority="high"
      />
      <div className="hero__wash" />
      <div className="hero__fade" />

      <div className="hero__body">
        <p className="hero__badge">
          <span className="hero__dot" />
          {t('hero:availability')}
        </p>
        <h1 className="hero__name">
          {t('hero:nameLine1')}
          <br />
          {t('hero:nameLine2')}
        </h1>
        <p className="hero__lede">{t('hero:lede')}</p>
      </div>
    </div>
  );
}
